export enum ESeancesListMode {
    DETAILED = "detailed",
    COMPACT = "compact"
}
